var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.gradesList,"item-value":"value","item-text":"text","label":_vm.$t(_vm.translateKey),"hide-details":_vm.hideDetails,"dense":_vm.dense,"outlined":"","clearable":""},on:{"change":_vm.onChange},model:{value:(_vm.grade),callback:function ($$v) {_vm.grade=$$v},expression:"grade"}})
}
var staticRenderFns = []

export { render, staticRenderFns }